// extracted by mini-css-extract-plugin
export default {"editSpeciesAndZones":"editSpeciesAndZones_editSpeciesAndZones__fenTA","section":"editSpeciesAndZones_section__EWUIY"};